import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ErrorComponent } from './error/error.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { environment } from 'src/environments/environment';
import { HomeComponent } from './home/home.component';
import { AuthGuard } from '../shared/auth.guard';
import { UserRole } from '../shared/auth.roles';
import {TermsOfUseComponent} from "./terms-of-use/terms-of-use.component";
import {PropplePoliciesComponent} from "./propple-policies/propple-policies.component";

const adminRoot = environment.adminRoot.substr(1); // path cannot start with a slash

let routes: Routes = [

  { path: 'terms-of-use', component: TermsOfUseComponent },
  {
    path: '',
    component: HomeComponent,
    pathMatch: 'full',
  },

  {
    path: adminRoot,
    loadChildren: () => import('./app/app.module').then((m) => m.AppModule),
    data: { roles: [UserRole.Admin, UserRole.Editor] },
    canActivate: [AuthGuard],
    // canActivateChild: [AuthGuard],
  },
  {
    path: 'user',
    loadChildren: () => import('./user/user.module').then((m) => m.UserModule),
  },
  { path: 'error', component: ErrorComponent },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: 'browser', loadChildren: () => import('./browser/browser.module').then(m => m.BrowserModule) },
  {
    path: 'signup',
    loadChildren: () => import('./add-property-new-user/add-property-new-user.module').then((m) => m.AddPropertyNewUserModule),
  },
  {
    path:'privacy-policy',
    component:PropplePoliciesComponent
  },
 { path: '**', redirectTo: '/error' },
];

if (!environment.isAuthGuardActive) {
  routes = [
    {
      path: '',
      component: HomeComponent,
      pathMatch: 'full',
    },
    {
      path: 'app',
      loadChildren: () => import('./app/app.module').then((m) => m.AppModule),
    },
    { path: 'error', component: ErrorComponent },
    {
      path: 'signup',
      loadChildren: () => import('./add-property-new-user/add-property-new-user.module').then((m) => m.AddPropertyNewUserModule),
    },
   { path: '**', redirectTo: '/error' },
  ];
}
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ViewRoutingModule {}
